// JS file for EventItem

import u from '@main';
import '@vendor/@fancyapps/ui/dist/fancybox.umd.js?24a2501bda15cec5e8cce7b0';
import '@vendor/owl.carousel/dist/owl.carousel.min.js?24a2501bda15cec5e8cce7b0';

u.importCSS('@vendor/@fancyapps/ui/dist/fancybox.css');
u.importCSS('@vendor/owl.carousel/dist/assets/owl.carousel.min.css');
u.importCSS('@vendor/owl.carousel/dist/assets/owl.theme.default.min.css');

Fancybox.bind('[data-fancybox]', {});

const imageCarousel = $('.j-carousel').owlCarousel({
  items: 1,
  loop: true,
  autoplay: false,
  center: true,
  dots: true,
  nav: false,
  smartSpeed: 750,
  responsive: {
    768: {
      items: 3,
      center: true,
    },
    1200: {
      items: 3,
      center: true,
    }
  }
});

$('.j-prev').on('click', function () {
  imageCarousel.trigger('prev.owl.carousel');
});

$('.j-next').on('click', function () {
  imageCarousel.trigger('next.owl.carousel');
});

$(() => {
  $('.j-carousel').find('.owl-dot').each(function (index) {
    $(this).val(index + 1);
    $(this).html('<span><span class="opacity-0 position-absolute">'+ (index + 1) + '</span></span>');
  });
});
